const storageTokensKey = 'sessionStorage.tokens'

export { storageTokensKey }
